<template>
  <div class="step">
    <ol class="status">
      <li :class="{'ing': step===1, 'passed': step>1 }">1<span class="hidden"></span></li>
      <li :class="{'ing': step===2, 'passed': step>2 }">2<span class="hidden"></span></li>
      <li :class="{'ing': step===3, 'passed': step>3 }">3<span class="hidden"></span></li>
      <li :class="{'ing': step===4, 'passed': step>4 }">4<span class="hidden"></span></li>
    </ol>
    <h2 class="stepTit">{{title}}</h2>
    <div class="subBlock"></div>
  </div>
</template>

<script>
export default {
  name: 'StepBar',
  props: [ 'step', 'title' ],
}
</script>

<style lang="css" scoped>
.status > :first-child, .stepTit{
  margin-left:0px;
}
</style>